module.exports = __webpack_public_path__ + "img/bocrm_logo_1l.f9e54756.png";